import React from 'react';

const looseProcessKey = (str) =>
  String(str ?? '')
    .toLowerCase()
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[^a-z0-9]/g, '');

/** Match inspection-report `process_description` to configured PQT test metadata. */
export const findPqtTestByProcessDescription = (processDescription, pqtTests) => {
  if (!processDescription || !Array.isArray(pqtTests) || pqtTests.length === 0) {
    return null;
  }
  const normalized = String(processDescription).trim().toLowerCase();
  const key = looseProcessKey(processDescription);

  return (
    pqtTests.find((test) => {
      const desc = test.processDescription ?? test.process_description ?? '';
      const text = String(desc).trim();
      if (!text) return false;
      return text.toLowerCase() === normalized || looseProcessKey(text) === key;
    }) || null
  );
};

/** Prefer API mandatory when present; otherwise resolve from PQT station test config. */
export const resolvePqtTestMandatory = (processDescription, apiMandatory, pqtTests) => {
  if (apiMandatory != null && apiMandatory !== '') {
    return apiMandatory;
  }
  const test = findPqtTestByProcessDescription(processDescription, pqtTests);
  return test?.mandatory ?? apiMandatory;
};

export const isPqtTestMandatory = (mandatory) => {
  if (mandatory === false || mandatory === 'false' || mandatory === 'False' || mandatory === 0 || mandatory === '0') {
    return false;
  }
  if (mandatory === true || mandatory === 'true' || mandatory === 'True' || mandatory === 1 || mandatory === '1') {
    return true;
  }
  return Boolean(mandatory);
};

export const formatMandatoryTestLabel = (label, mandatory) => {
  const text = String(label ?? '').trim();
  if (!text || !isPqtTestMandatory(mandatory)) return text;
  return `${text} *`;
};

export const PqtMandatoryTestLabel = ({ label, mandatory, className }) => {
  const text = String(label ?? '').trim();
  if (!text) return null;
  const mandatoryMark = isPqtTestMandatory(mandatory);

  return (
    <span className={className}>
      {text}
      {mandatoryMark ? (
        <span className="pqt-test-mandatory-mark" aria-hidden>
          {' *'}
        </span>
      ) : null}
    </span>
  );
};
